<template>
    <div id="un-authorised" class="page">
        <div class="auth-header bg-primary"></div>
        <div class="container d-flex justify-content-center align-items-center" style="min-height: 70vh;">
            <div class="text-center">
                <h1 class="text-danger">Unauthorized Access</h1>
                <p class="text-danger">You do not have permission to access this page.</p>
            </div>
        </div>
    </div>
    <llp-footer></llp-footer>
</template>
